/**
 * 管理端  客户管理
 */
 <template>
    <div class="login-page">
      <topInfo></topInfo>
      <agentNav></agentNav>
      <!-- 主体内容 -->
      <div class="eval-content" style="margin-bottom: 40px;">
         <div style="display: flex;">
            <div class="eval-content-item">
               <div class="eval-con-top" style="font-size: 14px;">
                  <div class="eval-con-title"><span style="font-weight: 700;">丨</span>案件详情</div>
               </div>
               <div style="font-size: 14px;" loading>
                  <div style="display: flex;margin: 10px 60px;">
                     <div style="width: 90px;text-align: left;">预申请名称：</div>
                     <div>{{ caseData.title }}</div>
                  </div>
                  <div style="display: flex;margin: 10px 60px;">
                     <div style="width: 90px;text-align: left;">预申请类型：</div>
                     <div>{{ caseData.type }}</div>
                  </div>
                  <div style="display: flex;margin: 10px 60px;">
                     <div style="width: 90px;text-align: left;">所属领域：</div>
                     <div>{{ caseData.area }}</div>
                  </div>
                  <div style="display: flex;margin: 10px 60px;">
                     <div style="width: 90px;text-align: left;">技术摘要：</div>
                     <div class="write-area no-select">{{ caseData.abstract }}</div>
                  </div>
                  <div style="display: flex;margin: 10px 60px;">
                     <div style="width: 90px;text-align: left;">权利要求：</div>
                     <div class="write-area no-select">{{ caseData.claim }}</div>
                  </div>
                  <div style="display: flex;margin: 10px 60px;">
                     <div style="width: 90px;text-align: left;">技术方案：</div>
                     <div class="write-area no-select">{{ caseData.fullText }}</div>
                  </div>
               </div>
            </div>
            <div class="eval-content-item" style="margin-left: 20px;">
               <div class="eval-con-top" style="font-size: 14px;">
                  <div class="eval-con-title"><span style="font-weight: 700;">丨</span>API查重</div>
               </div>
               <!-- 智能评估内容 -->
               <div class="eval-content-body" style="height: 485px;overflow-y: auto;" reportDataLoading>
                  <table style="width: 100%;border-collapse: collapse;table-layout: fixed;">
                     <tr>
                        <td colspan="3" style="font-weight: 700;">待申请专利整体评价结果</td>
                     </tr>
                     <tr>
                        <td colspan="3"style="font-size: 14px;">
                           您的专利申请综合评价良好，被评为级<span style="color: #2A91DD;"> {{ caseReportData.subItems.level }} </span>，共计<span style="color: #2A91DD;"> {{ caseReportData.subItems.starNum }} </span>星(最高15星)
                        </td>
                     </tr>
                     <tr>
                        <td colspan="3" style="font-size: 12px;text-align: left;padding: 2px 4px;">
                           注:综合评价分级表，会对待申请专利进行A至D之间的综合评级，A为最高，D为最低。共计0-15星。综合分级打分的结果，可以便于用户对待申请专利进行分级分类处置。
                        </td>
                     </tr>
                     <tr>
                        <td colspan="3" class="table-border" style="background-color: #2A91DD;color: #FFFFFF;">分项评价结果</td>
                     </tr>
                     <tr style="font-size: 14px;">
                        <td colspan="1" class="table-border">可专利性评价</td>
                        <td colspan="1" class="table-border">技术竞争</td>
                        <td colspan="1" class="table-border">市场前景</td>
                     </tr>
                     <tr style="font-size: 14px;">
                        <td colspan="1" class="table-border" style="color: #2A91DD;">{{ caseReportData.subItems.viabilityStar }}</td>
                        <td colspan="1" class="table-border" style="color: #2A91DD;">{{ caseReportData.subItems.techStar }}</td>
                        <td colspan="1" class="table-border" style="color: #2A91DD;">{{ caseReportData.subItems.marketStar }}</td>
                     </tr>
                     <tr>
                        <td colspan="3" class="table-border" style="background-color: #2A91DD;color: #FFFFFF;">智能评价建议</td>
                     </tr>
                     <tr style="font-size: 12px;">
                        <td class="table-border" style="text-align: left;padding: 2px 4px;">{{ caseReportData.subItems.viabilityAdvise }}</td>
                        <td class="table-border" style="text-align: left;padding: 2px 4px;">{{ caseReportData.subItems.techAdvise  }}</td>
                        <td class="table-border" style="text-align: left;padding: 2px 4px;">{{ caseReportData.subItems.marketAdvise }}</td>
                     </tr>
                     <tr>
                        <td colspan="3" style="font-size: 12px;text-align: left;padding: 2px 4px;">
                           注:分项评价表针对待申请专利，从可专利性、技术竞争、市场前景三个方面进行分项评价。其中:
                        </td>
                     </tr>
                     <tr>
                        <td colspan="3" style="font-size: 12px;text-align: left;padding: 2px 4px;">
                           ***可专利性主要侧重于评价待申请专利技术的新颖性;
                        </td>
                     </tr>
                     <tr>
                        <td colspan="3" style="font-size: 12px;text-align: left;padding: 2px 4px;">
                           ***技术竞争主要侧重于评价相关技术的竞争状况;
                        </td>
                     </tr>
                     <tr>
                        <td colspan="3" style="font-size: 12px;text-align: left;padding: 2px 4px;">
                           ***市场前景主要侧重于预测待申请专利技术的市场前景。
                        </td>
                     </tr>
                     <tr>
                        <td colspan="3" style="font-size: 12px;text-align: left;padding: 2px 4px;">
                           按照五星制标准，五颗星级分别对应优、良、中、差、很差。系统同样会智能化的给出处置建议。
                        </td>
                     </tr>
                  </table>
                  <table style="border-collapse: collapse;">
                     <tr>
                        <td colspan="3" class="table-border" style="background-color: #2A91DD;color: #FFFFFF;">综合评价分类结果</td>
                     </tr>
                     <tr v-for="item in caseReportData.ipcData" style="font-size: 12px;">
                        <td colspan="1" class="table-border" style="padding: 2px 4px;">{{ item.ipc }}</td>
                        <td colspan="2" class="table-border" style="text-align: left;padding: 2px 4px;">{{ item.ipcText }}</td>
                     </tr>
                     <tr>
                        <td colspan="3" style="font-size: 12px;text-align: left;padding: 2px 4px;">
                           注:综合分类评价表，会对待申请专利进行智能IPC分类。智能分类结果，可以方便用户对待申请专利进行分类管理，并根据不同技术分类，采取不同的申请策略。
                        </td>
                     </tr>
                  </table>
                  <table style="border-collapse: collapse;width: 100%;margin-top: 10px;table-layout: fixed;text-align: left;">
                     <tr>
                        <td colspan="3" style="text-align: center;font-weight: 700;">可专利性分析</td>
                     </tr>
                     <tr>
                        <td colspan="3" style="font-size: 14px;">权利要求项分析</td>
                     </tr>
                     <tr>
                        <td colspan="3" class="table-border" style="text-align: center;background-color: #2A91DD;color: #FFFFFF;">综合分析表</td>
                     </tr>
                     <tr style="font-size: 12px;">
                        <td colspan="1" style="border: 1px solid #D3D3D3;padding: 4px;background-color: #F1F1F1;">当前申请的权利要求数量</td>
                        <td colspan="2" class="table-border" style="">{{ caseReportData.innovations.claimCnt }}项</td>
                     </tr>
                     <tr style="font-size: 12px;">
                        <td rowspan="3" colspan="1" style="border: 1px solid #D3D3D3;padding: 4px;background-color: #F1F1F1;">系统判断存在抵触风险的权利要求</td>
                        <td colspan="2" class="table-border" style="padding: 4px;">{{ caseReportData.innovations.riskClaimsNum }}项</td>
                     </tr>
                     <tr style="font-size: 12px;">
                        <td colspan="1" style="border: 1px solid #D3D3D3;padding: 4px;background-color: #F1F1F1;text-align: left;">权项定位</td>
                        <td colspan="1" class="table-border" style="padding: 4px;">权利要求项{{ caseReportData.innovations.riskClaimsText }}</td>
                     </tr>
                     <tr style="font-size: 12px;">
                        <td colspan="1" style="border: 1px solid #D3D3D3;padding: 4px;background-color: #F1F1F1;text-align: left;">综合抵触度</td>
                        <td colspan="1" class="table-border" style="padding: 4px;">{{ caseReportData.innovations.riskClaimsScore }}</td>
                     </tr>
                     <tr style="font-size: 12px;">
                        <td rowspan="3" colspan="1" style="border: 1px solid #D3D3D3;padding: 4px;background-color: #F1F1F1;">系统判定低风险的权利要求</td>
                        <td colspan="2" class="table-border">{{ caseReportData.innovations.lowRiskClaimsNum }}项</td>
                     </tr>
                     <tr style="font-size: 12px;">
                        <td colspan="1" style="border: 1px solid #D3D3D3;padding: 4px;background-color: #F1F1F1;text-align: left;">权项定位</td>
                        <td colspan="1" class="table-border" style="padding: 4px;">权利要求项{{ caseReportData.innovations.lowRiskClaimsText }}</td>
                     </tr>
                     <tr style="font-size: 12px;">
                        <td colspan="1" style="border: 1px solid #D3D3D3;padding: 4px;background-color: #F1F1F1;text-align: left;">综合风险度</td>
                        <td colspan="1" class="table-border" style="padding: 4px;">{{ caseReportData.innovations.lowRiskClaimsScore }}</td>
                     </tr>
                     <tr style="font-size: 12px;">
                        <td colspan="1" style="border: 1px solid #D3D3D3;padding: 4px;background-color: #F1F1F1;">主权利要求项抵触风险</td>
                        <td colspan="2" class="table-border" style="padding: 4px;">{{ caseReportData.innovations.claimRisk }}</td>
                     </tr>
                     <tr>
                        <td colspan="3" style="font-size: 12px;">注:权利要求项分析主要侧重于综合性的给出待申请专利各个权利要求项的抵触风险程度。表中会注明高抵触风险的权利要求项数量，以及定位具体的权利要求项。表中还会同样标出低风险的权利要求项。同时，表中会单独给出主权利要求项的抵触风险。这些抵触风险全部用百分比显示，用于提供给用户，综合判断待申请专利的权利要求项创新性。便于后续调整申请策略。</td>
                     </tr>
                     <tr>
                        <td colspan="3" class="table-border" style="text-align: center;background-color: #2A91DD;color: #FFFFFF;">权利要求项抵触排查表</td>
                     </tr>
                     <tr>
                        <td colspan="1" class="table-border" style="padding: 4px;font-size: 14px;">权利要求项</td>
                        <td colspan="2" class="table-border" style="padding: 4px;font-size: 14px;">疑似对比专利</td>
                     </tr>
                     <tr v-for="item in caseReportData.innovations.claimConflict" style="font-size: 12px;">
                        <td colspan="1" class="table-border" style="padding: 4px;">权利要求{{ item.claimKey }}</td>
                        <td colspan="2" class="table-border" style="padding: 4px;">{{ item.pn }}&nbsp;&nbsp;{{ item.ti }}</td>
                     </tr>
                     <tr>
                        <td colspan="3" style="font-size: 12px;">注:权利要求项抵触排查表给出了高抵触风险的权利要求项以及对应的相似专利。提供该表的作用，在于提醒用户针对这些专利进行逐项排查，确定对应权利要求项是否存在新颖性或创造性，以便在后续申请中进行调整。</td>
                     </tr>
                     <tr>
                        <td colspan="3" class="table-border" style="text-align: center;background-color: #2A91DD;color: #FFFFFF;">疑似对比文献表</td>
                     </tr>
                     <tr>
                        <td colspan="1" class="table-border" style="padding: 4px;font-size: 14px;">疑似对比文献号</td>
                        <td colspan="1" class="table-border" style="padding: 4px;font-size: 14px;">专利名称</td>
                        <td colspan="1" class="table-border" style="padding: 4px;font-size: 14px;">可能影响的权利要求项</td>
                     </tr>
                     <tr style="font-size: 12px;" v-for="item in caseReportData.innovations.docFeature">
                        <td colspan="1" class="table-border" style="padding: 4px;">{{ item.pn }}</td>
                        <td colspan="1" class="table-border" style="padding: 4px;">{{ item.ti }}</td>
                        <td colspan="1" class="table-border" style="padding: 4px;">{{ item.claims }}</td>
                     </tr>
                     <tr>
                        <td colspan="3" style="font-size: 12px;">注:疑似对比文献表，给出了可能会影响当前专利新颖性和创造性的专利文献列表。建议用户对该表中列出的疑似对比文献进行通读和排查，进一步判断待申请专利的可专利性。</td>
                     </tr>
                     <tr>
                        <td colspan="3" style="text-align: left;font-size: 14px;font-weight: 700;padding:4px 0px;">相似专利列表（5）</td>
                     </tr>
                  </table>
                  <div>
                     <div v-for="(item,index) in caseReportData.patents" style="font-size: 12px;text-align: left;margin-top: 10px;">
                        <div>
                           <span style="font-weight: 700;">{{ index+1 }}.{{ item.ti }}</span>
                           <span style="margin-left: 30px;background-color: #2A91DD;padding: 2px 4px;border-radius: 4px;color: #FFFFFF;">{{ item.type }}</span>
                        </div>
                        <div style="color: #2A91DD;display: flex;margin-top: 4px;font-weight: 700;">
                           <div style="width: 50%;">
                              <span>可能影响的权利要求项：</span>
                              <span v-if="item.claims.length > 0" v-for="itemI in item.claims">{{ itemI }}</span>
                              <span v-if="item.claims.length <= 0">-</span>
                           </div>
                           <div style="width: 50%;">
                              <span>专利相似度：</span>
                              <span>{{ item.relevance }}</span>
                           </div>
                        </div>
                        <div style="color: #2A91DD;display: flex;margin-top: 4px;">
                           <div style="width: 50%;">
                              <span style="font-weight: 700;">申请号：</span>
                              <span>{{ item.an }}</span>
                           </div>
                           <div style="width: 50%;">
                              <span style="font-weight: 700;">申请日：</span>
                              <span>{{ item.ad }}</span>
                           </div>
                        </div>
                        <div style="color: #2A91DD;display: flex;margin-top: 4px;">
                           <div style="width: 50%;">
                              <span style="font-weight: 700;">公开号：</span>
                              <span>{{ item.pn }}</span>
                           </div>
                           <div style="width: 50%;">
                              <span style="font-weight: 700;">公开日：</span>
                              <span>{{ item.pd }}</span>
                           </div>
                        </div>
                        <div style="margin-top: 4px;">
                           <span style="font-weight: 700;">国际分类号：</span>
                           <span>{{ item.ipcText }}</span>
                        </div>
                        <div style="margin-top: 4px;">
                           <span style="font-weight: 700;">申请（专利权）人：</span>
                           <span>{{ item.applicantText }}</span>
                        </div>
                        <div style="margin-top: 4px;">
                           <span style="font-weight: 700;">发明（设计）人：</span>
                           <span>{{ item.inventorText }}</span>
                        </div>
                        <div style="margin-top: 4px;font-weight: 700;">摘要</div>
                        <div><span style="color: #FFFFFF;">占位</span>{{ item.abs }}</div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
         <!-- 附图数据 -->
         <div v-if="figureData&&figureData.length>0" class="eval-content-item" style="background-color: #FFFFFF;width: 1200px;margin-top: 10px;">
            <div class="eval-con-top" style="font-size: 14px;">
               <div class="eval-con-title"><span style="font-weight: 700;">丨</span>相关附图</div>
            </div>
            <div style="display: flex;margin: 0px 40px;padding-bottom: 10px;">
               <img v-for="item in figureData" :src="item.pre_figure_url" class="figure-img" @click="preview(item)"/>
            </div>
         </div>
         <div>
            <div class="eval-content-item" style="background-color: #FFFFFF;width: 1200px;">
               <div class="eval-con-top" style="font-size: 14px;">
                  <div class="eval-con-title"><span style="font-weight: 700;">丨</span>专家结论</div>
                  <div class="eval-con-btn" style="margin-left: auto;" @click="commitResult()">提交结论</div>
                  <div class="eval-con-btn" style="background-color: #F56C6C;" @click="backCase()">回退案件</div>
               </div>
               <div style="margin: -10px 20px;">
                  <el-form v-model="agentResultForm" style="margin:0px 20px;padding-bottom: 30px;">
                     <el-form-item prop="result" class="required-label" label="检索策略">
                        <el-input type="textarea" v-model="agentResultForm.strategy" placeholder="本次检索使用中知慧海知识产权数据库，采用分总结合的策略，运用布尔逻辑运算符构建检索表达式，开展关键词（拓展词）与分类号的检索，根据摘要和附图对检索结果进行去噪与筛选，逐步聚焦，实现精确检索的目标。" clearable></el-input>
                     </el-form-item>
                     <el-form-item prop="result" class="required-label" label="检索表达式">
                        <el-input type="textarea" v-model="agentResultForm.expression" placeholder="" clearable></el-input>
                     </el-form-item>
                     <el-form-item prop="result" class="required-label" label="检索结果">
                        <el-input type="textarea" v-model="agentResultForm.result" placeholder="" clearable></el-input>
                     </el-form-item>
                     <el-form-item prop="result" class="required-label" label="检索分析">
                        <el-input type="textarea" v-model="agentResultForm.analysis" placeholder="1，实用性分析: ；2，新颖性分析: ；3，创造性分析： 。" clearable></el-input>
                     </el-form-item>
                     <el-form-item prop="result" class="required-label" label="申请建议">
                        <el-radio-group v-model="agentResultForm.suggestion" class="vertical-group">
                           <el-radio style="margin-top: 20px;margin-left: 20px;" label="积极申请专利保护（未检出相同或相近似的对比文件，授权前景良好）">A 积极申请专利保护（未检出相同或相近似的对比文件，授权前景良好）</el-radio>
                           <el-radio style="margin-top: 20px;margin-left: 20px;" label="建议申请专利保护（与现有公开对比文件重合度较低，授权前景较好）">B 建议申请专利保护（与现有公开对比文件重合度较低，授权前景较好）</el-radio>
                           <el-radio style="margin-top: 20px;margin-left: 20px;" label="谨慎考虑专利申请（检出相近似的对比文件重合度较高，授权风险较大）">C 谨慎考虑专利申请（检出相近似的对比文件重合度较高，授权风险较大）</el-radio>
                           <el-radio style="margin-top: 20px;margin-left: 20px;margin-bottom: 20px;" label="不建议申请专利（检出相同或高近似的对比文件，没有授权前景）">D 不建议申请专利（检出相同或高近似的对比文件，没有授权前景）</el-radio>
                        </el-radio-group>
                     </el-form-item>
                     <el-form-item class="required-label" label="评估专家">
                        <div class="vertical-group" style="padding-left: 30px;color: #606266;">
                           {{ agentData.name }}
                        </div>
                     </el-form-item>
                  </el-form>
               </div>
            </div>
         </div>
      </div>
      <!-- 图片预览 -->
      <el-dialog :visible.sync="dialogVisible">
         <img width="100%" :src="dialogImageUrl" alt="">
      </el-dialog>
    </div>
 </template>
 <script>
   import { 
      getCaseTaskInfo,
      getCaseTaskReportDataInfo,
      handleCaseTask,
      backCaseTask
   } from '../../api/evalMG'
   import Pagination from '../../components/Pagination'
   import topInfo from '../../components/topInfo'
   import agentNav from '../../components/agentNav'
   export default {
      data() {
         return {
            loading: false,
            reportDataLoading: false,
            agentData: [],
            caseData: [],
            caseReportData: [],
            figureData: [],
            agentResultForm: {
               task_id: '',
               strategy: '',
               expression: '',
               result: '',
               analysis: '',
               suggestion: ''
            },
            dialogVisible: false,
            dialogImageUrl: '',

            formInline: {
               page: 1,
               ps: 10,
               keyword: ''
            },
            // 分页参数
            pageparm: {
               currentPage: 1,
               pageSize: 10,
               total: 10
            }
         }
      },
      // 注册组件
      components: {
         Pagination,
         topInfo,
         agentNav
      },
      created(){
         // 获取专家信息
         let agent = localStorage.getItem('userData')
         this.agentData = JSON.parse(agent)
      },
      mounted(){
         let task_id = this.$route.query.id
         if(!task_id || task_id.length <= 0){
            // 跳转待评估页面
            this.$router.push({ path: '/agent/waitEval'});
            return
         }
         this.agentResultForm.task_id = task_id
         this.getCaseInfo(task_id)
         this.getCaseReportDataInfo(task_id)
      },
      methods: {
         // 跳转待评估案件
         jumpWait(){
            this.$router.push({ path: '/agent/waitEval'});
         },
         // 跳转专家撰写
         jumpWrite(){
            this.$message({
               type: 'warning',
               message: '请选择需要撰写的案件'
            })
            // this.$router.push({ path: '/agent/writeEval'});
         },
         // 跳转评估记录
         jumpEvalRecord(){
            this.$router.push({ path: '/agent/agentEvalRecord'});
         },
         // 跳转个人中心
         jumpPersonCenter(){
            this.$router.push({ path: '/agent/agentPersonCenter'});
         },
         // 查询案件详情
         getCaseInfo(id){
            this.loading = true
            let param = {
               task_id: id
            }
            getCaseTaskInfo(param)
            .then(res=>{
               if(res.code == 200){
                  this.caseData = res.data
                  this.figureData = res.data.figureData
                  this.loading = false
               }else{
                  this.$message({
                     type: 'warning',
                     message: res.msg
                  })
                  this.loading = false
               }
            })
         },
         // 查询案件报告详情
         getCaseReportDataInfo(id){
            this.reportDataLoading = true
            let param = {
               task_id: id
            }
            getCaseTaskReportDataInfo(param)
            .then(res=>{
               if(res.code == 200){
                  this.caseReportData = res.data
                  this.reportDataLoading = false
               }else{
                  this.$message({
                     type: 'warning',
                     message: res.msg
                  })
                  this.reportDataLoading = false
               }
            })
         },
         // 分页插件事件
         callFather(parm) {
            this.formInline.page = parm.currentPage
            this.formInline.ps = parm.pageSize
         },
         // 回退案件
         backCase(){
           let task_id = this.agentResultForm.task_id
           this.$confirm('确定要回退案件?', '提示', {
               confirmButtonText: '确定',
               cancelButtonText: '取消',
               type: 'warning'
            })
            .then(()=>{
               let param = {
                  task_id: task_id
               }
               backCaseTask(param)
               .then(res=>{
                  if(res.code == 200){
                     this.$message({
                     type: 'success',
                     message: res.msg
                  })
                  // 跳转待评估列表
                  setTimeout(()=>{
                     this.$router.push({ path: '/agent/waitEval'});
                  },1000)
                  }else{
                     this.$message({
                        type: 'warning',
                        message: res.msg
                     })
                  }
               })
            })
            .catch(() => {
               this.$message({
                  type: 'info',
                  message: '已取消'
               })
            })
         },
         // 专家提交结论
         commitResult(){
            let data = this.agentResultForm
            if(data.expression.length <= 0){
               this.$message({
                  type: 'warning',
                  message: '检索表达式不能为空!'
               })
               return false
            }
            if(data.result.length <= 0){
               this.$message({
                  type: 'warning',
                  message: '检索结果不能为空!'
               })
               return false
            }
            if(data.analysis.length <= 0){
               this.$message({
                  type: 'warning',
                  message: '结果分析不能为空!'
               })
               return false
            }
            if(data.suggestion.length <= 0){
               this.$message({
                  type: 'warning',
                  message: '申请建议!'
               })
               return false
            }
            let param = {
               task_id: data.task_id,
               strategy: data.strategy,
               expression: data.expression,
               result: data.result,
               analysis: data.analysis,
               suggestion: data.suggestion
            }
            handleCaseTask(param)
            .then(res=>{
               if(res.code == 200){
                  this.$message({
                     type: 'success',
                     message: res.msg
                  })
                  // 跳转待评估列表
                  setTimeout(()=>{
                     this.$router.push({ path: '/agent/waitEval'});
                  },1000)
               }else{
                  this.$message({
                     type: 'warning',
                     message: res.msg
                  })
               }
            })
         },
         // 预览附图
         preview(val){
            let url = val.pre_figure_url
            this.dialogImageUrl = url
            this.dialogVisible = true
         },
      }
   }
</script>
<style scoped>
  .login-page {
    text-align: center;
    /* height: 100%; */
  }
  .login-title {
    font-size: 44px;
    font-weight: 700;
    padding-top: 24px;
  }
  .login-title-en {
    font-size: 16px;
    color: #5a5a5a;
    margin-top: 10px;
  }
  .eval-content {
   width: 1200px;
   /* height: 600px; */
   margin: 0px auto;
   /* background-color: #fff; */
   border-radius: 10px;
  }
  .eval-content-item {
   width: 590px;
   border-radius: 10px;
   background-color: #fff;
  }
  .eval-con-top {
   display: flex;
   margin: 10px 40px;
   padding: 16px 0px;
   border-bottom: 2px solid #eeeeee;
  }
  .eval-con-title {
   color: #2A91DD;
   height: 36px;
   line-height: 36px;
   font-size: 16px;
   font-weight: 700;
  }
  .eval-con-btn {
   width: 100px;
   height: 36px;
   line-height: 36px;
   text-align: center;
   color: #fff;
   background-color: #2A91DD;
   border-radius: 5px;
   margin-left: 20px;
   cursor: pointer;
  }
  .eval-con-search {
   margin-left: 20px;
  }
  .eval-con-search>>>.el-input-group {
   border-radius: 10px !important;
  }
  .eval-con-search>>>.el-input-group__append, .el-input-group__prepend {
   color: #FFFFFF;
   background-color: #2A91DD;
   cursor: pointer;
  }
  .eval-con-search>>>.el-input__inner {
   background-color: #F3F3F3 !important;
   border: none;
  }
  .eval-table {
   width: 1120px;
   margin: 0px auto;
  }
  .eval-table>>> .el-table__header th {
   background-color: #2A91DD !important;
  }
  .eval-table>>> .el-table thead {
   color: #FFFFFF;
  }
  .write-area {
   width: 360px;
   text-align:left;
   height: 120px;
   overflow-y: auto;
   padding: 2px 4px;
   border: 1px solid #F3F3F3;
  }
  .eval-content-body {
   margin: 10px 60px;
  }
  .table-border {
   border: 1px solid #f3f3f3;
  }
  .no-select {
   -webkit-user-select: none; 
   -moz-user-select: none; 
   -ms-user-select: none; 
   user-select: none;
  }
  .figure-img {
   width: 120px;
   height: 120px;
   margin-right: 10px;
   border: 1px solid #c0ccda;
   border-radius: 6px;
   cursor: pointer;
  }
  .required-label>>>.el-form-item__label::before{
   content: '* ';
   color: red;
   margin-top: 10px;
   }
   .vertical-group {
      display: flex;
      flex-direction: column;
      text-align: left;
      border: 1px solid #DCDFE6;
      border-radius: 4px;
      margin-top: 40px;
   }
</style>


// WEBPACK FOOTER //
// src/views/agent/writeEval.vue